import React, { useEffect, useState } from 'react';
import * as S from './styles';
import Buy from './Buy';
import WaitingPayment from './WaitingPayment';
import BenefitsSignature from './Benefits';
import { api } from 'services/api';
import loadingIcon from 'assets/image/loading.svg';

interface IAddEnvelopes {
  closeDrawer: () => void;
  idInternalProduct?: number
}
const AddEnvelopes = ({ closeDrawer, idInternalProduct }: IAddEnvelopes) => {
  const [drawerOption, setDrawerOption] = useState<
    'buy' | 'waitingPayment' | 'benefits'
  >('benefits');
  const [loading, setLoading] = useState(true)
  const [cases, setCases] = useState<any>()
  const GetCases = async () => {
    const accessToken = localStorage.getItem('accessToken');
    const idToken = localStorage.getItem('idToken');
    setLoading(true)
    try {
      const { data } = await api.get(
        `case?id_internal_product=${idInternalProduct}&type=novo`,
        {
          headers: {
            'content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
            idToken,
          },
        },
      );
      if(data.data.id_case){ 
        setCases(data.data)
        setDrawerOption('waitingPayment')
      }
      
      setLoading(false)

    } catch (error) {
    setLoading(false)
      console.log(error)
    }
  };
  useEffect(() => {
 
    GetCases();
    //eslint-disable-next-line
  }, []);
  const Loader = () => {
    return (
      <S.Loader>
        <img src={loadingIcon} width={36} height={36} />
      </S.Loader>
    );
  };
  return (
    <S.StyledDrawer open size="default" onCompleteClose={closeDrawer} noHeader>
      {loading ? <Loader /> : <>
      {drawerOption === 'buy' && (
        <Buy
          closeDrawer={closeDrawer}
          setDrawerOption={() => {
            GetCases()
          }
          }
          idInternalProduct={idInternalProduct}
        />
      )}
        {drawerOption === 'waitingPayment' && (
          <WaitingPayment closeDrawer={closeDrawer} cases={cases} />
        )}
        {drawerOption === 'benefits' && (
          <BenefitsSignature
            closeDrawer={closeDrawer}
            setDrawerOption={() => setDrawerOption('buy')}
          />
        )}
        </>}


    </S.StyledDrawer>
  );
};
export default AddEnvelopes;
